import React from 'react';

import { useGroupState, useGroupActions } from './GroupContext';
import { destroyGroup } from './restApi';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';

import styles from './DeleteGroupForm.module.scss';

const DeleteGroupForm = () => {
  const state = useGroupState();
  const { onResponse, onError, updateDeleteGroupConfirmationPhrase, updateDeleteGroupPassword, closeDeleteGroupModal } = useGroupActions();

  const groupName = state?.group?.name || '';
  const expectedPhrase = `Delete ${groupName}`;
  const phraseMatches = state?.deleteGroupConfirmationPhrase === expectedPhrase;
  const passwordPresent = (state?.deleteGroupPassword || '').length > 0;

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    destroyGroup({
      id: state?.group?.id,
      onResponse,
      onError,
      body: {
        password: state?.deleteGroupPassword || '',
        confirmationPhrase: state?.deleteGroupConfirmationPhrase || '',
        authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className={styles.warningSection}>
        <h3 className={styles.warningTitle}>Delete Group</h3>
        <p className={styles.warningText}>
          This action is <strong>permanent and cannot be undone</strong>. Deleting this group will:
        </p>
        <ul className={styles.warningList}>
          <li>Remove all group roles and member associations</li>
          <li>Remove all permissions (restricted actions) for this group</li>
          <li>Delete all group membership invitations</li>
          <li>Delete all budgets and their expenses</li>
          <li>Delete all purchase order groups, purchase orders, and receipts</li>
          <li>Delete all inventories and their items</li>
          <li>Remove the group profile picture</li>
        </ul>
        <p className={styles.preservedText}>
          Member job prospects and user accounts will <strong>not</strong> be affected.
        </p>
      </div>

      <Field
        label={`Type "${expectedPhrase}" to confirm`}
        id="delete_group_confirmation_phrase"
      >
        <Input
          type="text"
          value={state?.deleteGroupConfirmationPhrase || ''}
          onChange={(e) => updateDeleteGroupConfirmationPhrase(e.target.value)}
        />
      </Field>

      <Field label="Password" id="delete_group_password">
        <Input
          type="password"
          value={state?.deleteGroupPassword || ''}
          onChange={(e) => updateDeleteGroupPassword(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeDeleteGroupModal()}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="destructive"
            disabled={!phraseMatches || !passwordPresent}
          >
            Delete Group Permanently
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default DeleteGroupForm;
